import { render } from "./LabelWithInput.vue?vue&type=template&id=36f73424&scoped=true"
import script from "./LabelWithInput.vue?vue&type=script&lang=js"
export * from "./LabelWithInput.vue?vue&type=script&lang=js"

import "./LabelWithInput.vue?vue&type=style&index=0&id=36f73424&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f73424"]])

export default __exports__